import axios from 'axios'

const state = {
  sampleRuns: [],
  currentRun: null,
  currentSubjectsPage: { results: [], page: 1, num_pages: 1, total: 0 },
  rereviewBatches: [],
  snapshots: [],
  loading: false,
  lastError: null,
}

const mutations = {
  setSampleRuns (state, runs) { state.sampleRuns = runs },
  setCurrentRun (state, run) { state.currentRun = run },
  setSubjectsPage (state, page) { state.currentSubjectsPage = page },
  upsertSubject (state, subject) {
    const idx = state.currentSubjectsPage.results.findIndex(s => s.id === subject.id)
    if (idx !== -1) state.currentSubjectsPage.results.splice(idx, 1, subject)
  },
  setRereviewBatches (state, batches) { state.rereviewBatches = batches },
  upsertRereviewBatch (state, batch) {
    const idx = state.rereviewBatches.findIndex(b => b.id === batch.id)
    if (idx !== -1) state.rereviewBatches.splice(idx, 1, batch)
    else state.rereviewBatches.unshift(batch)
  },
  setSnapshots (state, snaps) { state.snapshots = snaps },
  prependSnapshot (state, snap) { state.snapshots.unshift(snap) },
  setLoading (state, loading) { state.loading = loading },
  setLastError (state, err) { state.lastError = err },
}

const actions = {
  fetchSampleRuns (context) {
    return axios.get('/api/verification/sample-runs/')
      .then(r => context.commit('setSampleRuns', r.data.results || r.data))
      .catch(e => { context.commit('setLastError', e); console.log(e) })
  },
  createSampleRun (context, payload) {
    return axios.post('/api/verification/sample-runs/', payload)
      .then(r => { context.commit('setCurrentRun', r.data); return r.data })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
  fetchSampleRun (context, runId) {
    return axios.get(`/api/verification/sample-runs/${runId}/`)
      .then(r => context.commit('setCurrentRun', r.data))
      .catch(e => { context.commit('setLastError', e); console.log(e) })
  },
  fetchSubjects (context, { runId, page = 1, pageSize = 20 }) {
    context.commit('setLoading', true)
    return axios.get(`/api/verification/sample-runs/${runId}/subjects/?page=${page}&page_size=${pageSize}`)
      .then(r => context.commit('setSubjectsPage', r.data))
      .catch(e => { context.commit('setLastError', e); console.log(e) })
      .finally(() => context.commit('setLoading', false))
  },
  submitSubject (context, { subjectId, judgments, notes, flagged_for_rereview }) {
    return axios.post(`/api/verification/subjects/${subjectId}/submit/`, {
      judgments, notes: notes || '', flagged_for_rereview: !!flagged_for_rereview,
    })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
  fetchRereviewBatches (context) {
    return axios.get('/api/verification/rereview-batches/')
      .then(r => context.commit('setRereviewBatches', r.data.results || r.data))
      .catch(e => { context.commit('setLastError', e); console.log(e) })
  },
  createRereviewBatch (context, payload) {
    return axios.post('/api/verification/rereview-batches/', payload)
      .then(r => { context.commit('upsertRereviewBatch', r.data); return r.data })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
  approveRereviewBatch (context, batchId) {
    return axios.post(`/api/verification/rereview-batches/${batchId}/approve/`)
      .then(r => { context.commit('upsertRereviewBatch', r.data); return r.data })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
  rejectRereviewBatch (context, batchId) {
    return axios.post(`/api/verification/rereview-batches/${batchId}/reject/`)
      .then(r => { context.commit('upsertRereviewBatch', r.data); return r.data })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
  fetchSnapshots (context) {
    return axios.get('/api/verification/snapshots/')
      .then(r => context.commit('setSnapshots', r.data.results || r.data))
      .catch(e => { context.commit('setLastError', e); console.log(e) })
  },
  takeSnapshot (context, { period_start, period_end }) {
    return axios.post('/api/verification/snapshots/take/', { period_start, period_end })
      .then(r => { context.commit('prependSnapshot', r.data); return r.data })
      .catch(e => { context.commit('setLastError', e); throw e })
  },
}

export default {
  state,
  mutations,
  actions,
}
